var exports = {};

function bounceOut(t) {
  var a = 4 / 11;
  var b = 8 / 11;
  var c = 9 / 10;
  var ca = 4356 / 361;
  var cb = 35442 / 1805;
  var cc = 16061 / 1805;
  var t2 = t * t;
  return t < a ? 7.5625 * t2 : t < b ? 9.075 * t2 - 9.9 * t + 3.4 : t < c ? ca * t2 - cb * t + cc : 10.8 * t * t - 20.52 * t + 10.72;
}

exports = bounceOut;
export default exports;